import cn from 'classnames';
import styles from './Features.module.css'

export interface FeaturesData {
  id: number
  text: string
  image?: string
}

export interface FeaturesProps {
  features: FeaturesData[]
  alignment?: 'center' | 'side'
  cardColor?: 'black' | 'white'
  hideIcons?: boolean
}

export default function Features({
  features,
  alignment = 'center',
  cardColor = 'white',
  hideIcons = false
}: FeaturesProps) {
  return (
    <div className={cn(styles.features_wrapper, styles[alignment])}>
      {features.map((feature: FeaturesData) => (
        <div
          className={cn(styles.card, styles[`card_${cardColor}`])}
          key={feature.id}
        >
          {!hideIcons && feature.image && (
            <div className={styles.icon_wrapper}>
              <img
                src={
                  feature.image?.startsWith('http') || feature.image?.startsWith('/media')
                    ? feature.image
                    : (() => {
                        try {
                          return require(`../../assets/icons/${feature.image}`);
                        } catch {
                          return '';
                        }
                      })()
                }
                alt={feature.text}
                onError={e => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
          )}
          <p className='text_body_b3'>{feature.text}</p>
        </div>
      ))}
    </div>
  )
}
